// extracted by mini-css-extract-plugin
export default {"button":"Button_button__cTUal","danger":"Button_danger__EgNBb","empty":"Button_empty__AzJuY"};